import { getMapsetBySEO } from "~/util/mapset";
import { buildLookupOptions, lookupbox } from "../poiagg";
import Scene from "~/scene";

export default class FotoWcamLookupbox {
	_request: any;

	_mapset: number;

	_sources: Array<string>;

	constructor() {
		this._request = null;
		this._mapset = getMapsetBySEO("fotografie").id;
		this._sources = [];
	}

	setSources({
		foto = false,
		webcams = false,
	} : {
		foto?: boolean;
		webcams?: boolean;
	}) {
		const newSources: Array<string> = [];

		if (foto) {
			newSources.push("foto");
		}

		if (webcams) {
			newSources.push("wcam");
		}

		this._sources = newSources;
	}

	lookupbox() {
		if (this._request) {
			this._request.abort();
			this._request = null;
		}

		const lookupOpts = buildLookupOptions(this._mapset, {
			approval: true,
			sources: this._sources,
		});
		const viewport = Scene.getViewport();
		const lookupboxData = lookupbox(viewport.lbx, viewport.lby, viewport.rtx, viewport.rty, lookupOpts);

		this._request = lookupboxData.request;

		return lookupboxData.promise;
	}
}
